import ImageMosaic from './ImageMosaic';

export default ImageMosaic;
